import { Button } from "../../ui/button";
import { useCalendarContext } from "../../calendar-context";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  format,
  addDays,
  addMonths,
  addWeeks,
  subDays,
  subMonths,
  subWeeks,
} from "date-fns";
import { useEffect, useState } from "react";
import DateRange from "@/components/common/DateRange";

export default function CalendarHeaderDateChevrons() {
  const { mode, date, setDate, endDate, setEndDate } = useCalendarContext();
  const [isDateRangeOpen, setDateRangeOpen] = useState(false);

  useEffect(() => {
    if (!endDate || !setEndDate) return;
    if (isDateRangeOpen) return;
    if (mode === 'day') setEndDate(date)
    if (mode === "week") setEndDate(addWeeks(date, 1));
    else if (mode === "month") setEndDate(addMonths(date, 1));
  }, [date, mode]);

  function handleDateBackward() {
    switch (mode) {
      case "month":
        setDate(subMonths(date, 1));
        break;
      case "week":
        setDate(subWeeks(date, 1));
        break;
      case "day":
        setDate(subDays(date, 1));
        break;
    }
  }

  function handleDateForward() {
    switch (mode) {
      case "month":
        setDate(addMonths(date, 1));
        break;
      case "week":
        setDate(addWeeks(date, 1));
        break;
      case "day":
        setDate(addDays(date, 1));
        break;
    }
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="outline"
          className="cursor-pointer h-7 w-7 p-1"
          onClick={handleDateBackward}
        >
          <ChevronLeft className="min-w-5 min-h-5" />
        </Button>

        <span
          onClick={() => setDateRangeOpen(true)}
          className="min-w-[140px] text-center font-medium cursor-pointer"
        >
          {(mode === "week" || mode === "month") && endDate
            ? `${format(date, "MMMM d, yyyy")} - ${format(endDate, "MMMM d, yyyy")}`
            : format(date, "MMMM d, yyyy")}
        </span>

        <Button
          type="button"
          variant="outline"
          className="cursor-pointer h-7 w-7 p-1"
          onClick={handleDateForward}
        >
          <ChevronRight className="min-w-5 min-h-5" />
        </Button>
      </div>
      {isDateRangeOpen && (
        <DateRange
          customOpen={isDateRangeOpen}
          setCustomOpen={setDateRangeOpen}
          startDate={date}
          setStartDate={setDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      )}
    </>
  );
}
